(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineEnumerableProperties", "@babel/runtime/helpers/extends", "lodash/isEmpty", "lodash/isPlainObject", "lodash/isFunction", "lodash/difference"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineEnumerableProperties"), require("@babel/runtime/helpers/extends"), require("lodash/isEmpty"), require("lodash/isPlainObject"), require("lodash/isFunction"), require("lodash/difference"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineEnumerableProperties, global._extends, global.isEmpty, global.isPlainObject, global.isFunction, global.difference);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineEnumerableProperties2, _extends3, _isEmpty, _isPlainObject, _isFunction, _difference) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports.dispatch = dispatch;
  _exports.emit = emit;
  _exports.observe = observe$1;
  _exports.off = off;
  _exports.on = on;
  _exports.once = once;
  _exports.useStore = useStore;
  _exports.globalStorage = _exports.globalProvider = void 0;
  _defineEnumerableProperties2 = _interopRequireDefault(_defineEnumerableProperties2);
  _extends3 = _interopRequireDefault(_extends3);
  _isEmpty = _interopRequireDefault(_isEmpty);
  _isPlainObject = _interopRequireDefault(_isPlainObject);
  _isFunction = _interopRequireDefault(_isFunction);
  _difference = _interopRequireDefault(_difference);

  var _size, _instrumentations, _mutatorMap;

  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

  function encrypt(before) {
    var after = String.fromCharCode(before.charCodeAt(0) + before.length);

    for (var i = 1; i < before.length; i++) {
      after += String.fromCharCode(before.charCodeAt(i) + before.charCodeAt(i - 1));
    }

    return escape(after);
  }

  function decrypt(after) {
    var _after = unescape(after);

    var before = String.fromCharCode(_after.charCodeAt(0) - _after.length);

    for (var i = 1; i < _after.length; i++) {
      before += String.fromCharCode(_after.charCodeAt(i) - before.charCodeAt(i - 1));
    }

    return before;
  }

  var FakeLocalStorage = /*#__PURE__*/function () {
    function FakeLocalStorage() {
      this.cache = {};
    }

    var _proto = FakeLocalStorage.prototype;

    _proto.setItem = function setItem(key, value) {
      this.cache[key] = value;
    };

    _proto.getItem = function getItem(key) {
      return this.cache[key];
    };

    _proto.removeItem = function removeItem(key) {
      delete this.cache[key];
    };

    return FakeLocalStorage;
  }();

  function storgeValueEncrypt(value) {
    return encrypt(JSON.stringify({
      content: value
    }));
  }

  function storgeValueDecrypt(value) {
    return JSON.parse(decrypt(value)).content;
  }

  var GlobalStorage = /*#__PURE__*/function () {
    function GlobalStorage() {
      this.cache = {};
      this.config = {
        devtool: true,
        localNamespace: ''
      };
      this.browserLocalStorage = isBrowser && window.localStorage ? window.localStorage : new FakeLocalStorage();
    }

    var _proto2 = GlobalStorage.prototype;

    _proto2.set = function set(key, value) {
      this.cache[key] = value;
    };

    _proto2.get = function get(key) {
      return this.cache[key];
    };

    _proto2.remove = function remove(key) {
      delete this.cache[key];
    };

    _proto2.list = function list() {
      return (0, _extends3["default"])({}, this.cache);
    };

    _proto2.setNamespace = function setNamespace(namespace) {
      this.config.localNamespace = namespace;
    };

    _proto2.handleLocalKey = function handleLocalKey(key) {
      return this.config.localNamespace ? [this.config.localNamespace, key].join('.') : key;
    };

    _proto2.setToLocal = function setToLocal(key, value, options) {
      var _ref = options || {},
          expired = _ref.expired,
          compile = _ref.compile;

      var _value = compile ? storgeValueEncrypt(value) : value;

      var data = {
        value: _value,
        writeTime: Date.now(),
        expired: expired,
        compile: compile
      };
      this.browserLocalStorage.setItem(this.handleLocalKey(key), JSON.stringify(data));
    };

    _proto2.getFormLocal = function getFormLocal(key) {
      var dataJSON = this.browserLocalStorage.getItem(this.handleLocalKey(key));

      if (this.isNotExist(dataJSON)) {
        return null;
      }

      var data = JSON.parse(dataJSON);

      if (this.isNotExist(data.expired)) {
        return data.compile ? storgeValueDecrypt(data.value) : data.value;
      }

      if (this.isOutPeriod(data)) {
        this.removeFormLocal(key);
        return null;
      }

      return data.compile ? storgeValueDecrypt(data.value) : data.value;
    };

    _proto2.removeFormLocal = function removeFormLocal(key) {
      this.browserLocalStorage.removeItem(this.handleLocalKey(key));
    };

    _proto2.isOutPeriod = function isOutPeriod(value) {
      if (!value.expired) {
        return false;
      }

      var readTime = Date.now();
      return readTime - value.writeTime > value.expired;
    };

    _proto2.isNotExist = function isNotExist(value) {
      return value === null || typeof value === 'undefined';
    };

    return GlobalStorage;
  }();

  var SPA_GLOBAL_STORAGE = Symbol["for"]('__SPA_GLOBAL_STORAGE__');

  var _global = function () {
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    if (typeof self !== 'undefined') return self;
    throw new Error('no global found');
  }();

  var _globalStorage;

  if (_global[SPA_GLOBAL_STORAGE]) {
    _globalStorage = _global[SPA_GLOBAL_STORAGE];
  } else {
    _globalStorage = new GlobalStorage();
    _global[SPA_GLOBAL_STORAGE] = _globalStorage;
  }

  var globalStorage = _globalStorage;
  _exports.globalStorage = globalStorage;
  var connectionStore = new WeakMap();
  var ITERATION_KEY = Symbol('iteration key');

  function storeObservable(value) {
    connectionStore.set(value, new Map());
  }

  function registerReactionForOperation(reaction, _ref2) {
    var target = _ref2.target,
        key = _ref2.key,
        type = _ref2.type;

    if (target === undefined) {
      return;
    }

    var _key = type === 'iterate' ? ITERATION_KEY : key;

    var reactionsForRaw = connectionStore.get(target);

    if (!reactionsForRaw || _key === undefined) {
      return;
    }

    var reactionsForKey = reactionsForRaw.get(_key);

    if (!reactionsForKey) {
      reactionsForKey = new Set();
      reactionsForRaw.set(_key, reactionsForKey);
    }

    if (!reactionsForKey.has(reaction)) {
      reactionsForKey.add(reaction);

      if (reaction.cleaners) {
        reaction.cleaners.push(reactionsForKey);
      } else {
        reaction.cleaners = [reactionsForKey];
      }
    }
  }

  function addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(function (reaction) {
      reactionsForKey.add(reaction);
    });
  }

  function getUpperRawReactionsForRawKeyOption(_ref3, reactionsForKey) {
    var target = _ref3.target,
        key = _ref3.key;

    if (reactionsForKey === void 0) {
      reactionsForKey = new Set();
    }

    var reactionsForTarget = connectionStore.get(target);

    if (!reactionsForTarget || key === undefined) {
      return reactionsForKey;
    }

    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(function (reaction) {
      if (reaction.deep && !reaction.unobserved) {
        reactionsForKey.add(reaction);
      }
    });
    var upperRawKeyOption = rawToUpperRawKeyOption.get(target);
    return upperRawKeyOption ? getUpperRawReactionsForRawKeyOption(upperRawKeyOption, reactionsForKey) : reactionsForKey;
  }

  function getReactionsForOperation(_ref4) {
    var target = _ref4.target,
        key = _ref4.key,
        type = _ref4.type;

    if (target === undefined) {
      return null;
    }

    var reactionsForKey = new Set();
    var reactionsForTarget = connectionStore.get(target);

    if (reactionsForTarget && key !== undefined) {
      addReactionsForKey(reactionsForKey, reactionsForTarget, key);

      if (type === 'add' || type === 'delete' || type === 'clear') {
        var iterationKey = Array.isArray(target) ? 'length' : ITERATION_KEY;
        addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
      }
    }

    var upperRawKeyOption = rawToUpperRawKeyOption.get(target);

    if (upperRawKeyOption) {
      getUpperRawReactionsForRawKeyOption(upperRawKeyOption, reactionsForKey);
    }

    return reactionsForKey;
  }

  function releaseReaction(reaction) {
    if (reaction.cleaners) {
      reaction.cleaners.forEach(function (reactionsForKey) {
        reactionsForKey["delete"](reaction);
      });
      reaction.cleaners = [];
    }
  }

  var reactionStack = [];

  function isRunning(reaction) {
    return reactionStack.includes(reaction);
  }

  function hasRunningReaction() {
    return reactionStack.length > 0;
  }

  function getRunningReaction() {
    var _reactionStack$slice = reactionStack.slice(-1),
        runningReaction = _reactionStack$slice[0];

    return runningReaction;
  }

  function registerRunningReaction(operation) {
    var runningReaction = getRunningReaction();

    if (runningReaction) {
      registerReactionForOperation(runningReaction, operation);
    }
  }

  function queueReactionsForOperation(operation) {
    var _a;

    (_a = getReactionsForOperation(operation)) === null || _a === void 0 ? void 0 : _a.forEach(function (reaction) {
      return reaction();
    });
  }

  function runReactionWrap(reaction, fn, context, args) {
    if (reaction.unobserved) {
      return Reflect.apply(fn, context, args);
    }

    if (isRunning(reaction)) {
      return;
    }

    releaseReaction(reaction);

    try {
      reactionStack.push(reaction);
      return Reflect.apply(fn, context, args);
    } finally {
      reactionStack.pop();
    }
  }

  function findReactive(obj) {
    var reactiveObj = rawToProxy.get(obj);

    if (hasRunningReaction() && isObject(obj)) {
      if (reactiveObj) {
        return reactiveObj;
      }

      return reactive(obj);
    }

    return reactiveObj || obj;
  }

  function patchIterator(iterator, isEntries) {
    var originalNext = iterator.next;

    iterator.next = function () {
      var _originalNext$call = originalNext.call(iterator),
          done = _originalNext$call.done,
          value = _originalNext$call.value;

      if (!done) {
        if (isEntries) {
          value[1] = findReactive(value[1]);
        } else {
          value = findReactive(value);
        }
      }

      return {
        done: done,
        value: value
      };
    };

    return iterator;
  }

  var instrumentations = (_instrumentations = {
    has: function has(key) {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        key: key,
        type: 'has'
      });
      return proto.has.call(target, key);
    },
    get: function get(key) {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        key: key,
        type: 'get'
      });
      return findReactive(proto.get.call(target, key));
    },
    forEach: function forEach(cb) {
      var _proto$forEach;

      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        type: 'iterate'
      });

      var wrappedCb = function wrappedCb(value) {
        for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key3 = 1; _key3 < _len2; _key3++) {
          rest[_key3 - 1] = arguments[_key3];
        }

        return cb.apply(void 0, [findReactive(value)].concat(rest));
      };

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return (_proto$forEach = proto.forEach).call.apply(_proto$forEach, [target, wrappedCb].concat(args));
    },
    set: function set(key, value) {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      var hadKey = proto.has.call(target, key);
      var oldValue = proto.get.call(target, key);
      var result = proto.set.call(target, key, value);

      if (!hadKey) {
        queueReactionsForOperation({
          target: target,
          key: key,
          type: 'add'
        });
      } else if (value !== oldValue) {
        queueReactionsForOperation({
          target: target,
          key: key,
          type: 'set'
        });
      }

      return result;
    },
    add: function add(key) {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      var hadKey = proto.has.call(target, key);
      var result = proto.add.call(target, key);

      if (!hadKey) {
        queueReactionsForOperation({
          target: target,
          key: key,
          type: 'add'
        });
      }

      return result;
    },
    "delete": function _delete(key) {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      var hadKey = proto.has.call(target, key);
      var result = proto["delete"].call(target, key);

      if (hadKey) {
        queueReactionsForOperation({
          target: target,
          key: key,
          type: 'delete'
        });
      }

      return result;
    },
    clear: function clear() {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      var hadItems = target.size !== 0;
      var result = proto.clear.call(target);

      if (hadItems) {
        queueReactionsForOperation({
          target: target,
          type: 'clear'
        });
      }

      return result;
    },
    keys: function keys() {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        type: 'iterate'
      });
      return proto.keys.call(target);
    },
    values: function values() {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        type: 'iterate'
      });
      var iterator = proto.values.call(target);
      return patchIterator(iterator, false);
    },
    entries: function entries() {
      var target = proxyToRaw.get(this);
      var proto = Reflect.getPrototypeOf(this);
      registerRunningReaction({
        target: target,
        type: 'iterate'
      });
      var iterator = proto.entries.call(target);
      return patchIterator(iterator, true);
    }
  }, _instrumentations[Symbol.iterator] = function () {
    var target = proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    registerRunningReaction({
      target: target,
      type: 'iterate'
    });
    var iterator = proto[Symbol.iterator].call(target);
    return patchIterator(iterator, target instanceof Map);
  }, _size = "size", _mutatorMap = {}, _mutatorMap[_size] = _mutatorMap[_size] || {}, _mutatorMap[_size].get = function () {
    var target = proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    registerRunningReaction({
      target: target,
      type: 'iterate'
    });
    return Reflect.get(proto, 'size', target);
  }, (0, _defineEnumerableProperties2["default"])(_instrumentations, _mutatorMap), _instrumentations);
  var collectionHandlers = {
    get: function get(target, key, receiver) {
      target = hasOwnProperty.call(instrumentations, key) ? instrumentations : target;
      return Reflect.get(target, key, receiver);
    }
  };
  var wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function (key) {
    return Symbol[key];
  }).filter(function (value) {
    return typeof value === 'symbol';
  }));

  function get(target, key, receiver) {
    var result = Reflect.get(target, key, receiver);

    if (typeof key === 'symbol' && wellKnownSymbols.has(key)) {
      return result;
    }

    registerRunningReaction({
      target: target,
      key: key,
      receiver: receiver,
      type: 'get'
    });
    var reativeResult = rawToProxy.get(result);

    if (isObject(result)) {
      if (reativeResult) {
        return reativeResult;
      }

      rawToUpperRawKeyOption.set(result, {
        target: target,
        key: key
      });
      return reactive(result);
    }

    return result;
  }

  function ownKeys(target) {
    registerRunningReaction({
      target: target,
      type: 'iterate'
    });
    return Reflect.ownKeys(target);
  }

  function set(target, key, value, receiver) {
    if (isObject(value)) {
      value = proxyToRaw.get(value) || value;
    }

    var hadKey = hasOwnProperty.call(target, key);
    var oldValue = target[key];
    var result = Reflect.set(target, key, value, receiver);

    if (!hadKey) {
      queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        receiver: receiver,
        type: 'add'
      });
    } else if (value !== oldValue) {
      queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        oldValue: oldValue,
        receiver: receiver,
        type: 'set'
      });
    }

    return result;
  }

  function deleteProperty(target, key) {
    var hadKey = hasOwnProperty.call(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);

    if (hadKey) {
      queueReactionsForOperation({
        target: target,
        key: key,
        oldValue: oldValue,
        type: 'delete'
      });
    }

    return result;
  }

  var baseHandlers = {
    get: get,
    set: set,
    ownKeys: ownKeys,
    deleteProperty: deleteProperty
  };
  var handlers = new Map([[Map, collectionHandlers], [Set, collectionHandlers], [WeakMap, collectionHandlers], [WeakSet, collectionHandlers], [Object, baseHandlers], [Array, baseHandlers], [Int8Array, baseHandlers], [Uint8Array, baseHandlers], [Uint8ClampedArray, baseHandlers], [Int16Array, baseHandlers], [Uint16Array, baseHandlers], [Int32Array, baseHandlers], [Uint32Array, baseHandlers], [Float32Array, baseHandlers], [Float64Array, baseHandlers]]);

  function getHandlers(obj) {
    return handlers.get(obj.constructor);
  }

  var proxyToRaw = new WeakMap();
  var rawToProxy = new WeakMap();
  var rawToUpperRawKeyOption = new WeakMap();

  function isObject(val) {
    return typeof val === 'object' && val !== null && val !== undefined;
  }

  var globalObj = typeof window === 'object' ? window : Function('return this')();

  function shouldInstrument(_ref5) {
    var constructor = _ref5.constructor;
    var isBuiltIn = typeof constructor === 'function' && constructor.name in globalObj && globalObj[constructor.name] === constructor;
    return !isBuiltIn || handlers.has(constructor);
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  function createReactive(target) {
    var _reactive = new Proxy(target, getHandlers(target));

    rawToProxy.set(target, _reactive);
    proxyToRaw.set(_reactive, target);
    storeObservable(target);
    return _reactive;
  }

  function reactive(target) {
    if (proxyToRaw.has(target) || !shouldInstrument(target)) {
      return target;
    }

    var existProxy = rawToProxy.get(target);

    if (existProxy) {
      return existProxy;
    }

    return createReactive(target);
  }

  var IS_REACTION = Symbol('is reaction');

  function _observe2(fn, options) {
    var _this = this;

    if (options === void 0) {
      options = {
        deep: true
      };
    }

    var _options = options,
        _options$deep = _options.deep,
        deep = _options$deep === void 0 ? true : _options$deep;

    if (fn[IS_REACTION]) {
      return fn;
    }

    var reaction = function reaction() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return runReactionWrap(reaction, fn, _this, args);
    };

    reaction.deep = deep;
    reaction();
    return reaction;
  }

  function unobserve(reaction) {
    if (!reaction.unobserved) {
      reaction.unobserved = true;
      releaseReaction(reaction);
    }
  }

  function deepCopy() {
    var options, prop, src, copy, copyIsArray, clone, target;
    var index = 1;

    if (arguments.length < 2) {
      var content = arguments.length <= 0 ? undefined : arguments[0];

      if (content === undefined && content === null) {
        return content;
      }

      target = (0, _isPlainObject["default"])(content) ? {} : Array.isArray(content) ? [] : content;
      index = target === content ? 1 : 0;
    } else {
      target = (arguments.length <= 0 ? undefined : arguments[0]) || {};

      if (typeof target !== 'object' && !(0, _isFunction["default"])(target)) {
        target = {};
      }
    }

    for (var i = index; i < arguments.length; i++) {
      if ((options = i < 0 || arguments.length <= i ? undefined : arguments[i]) != null) {
        for (prop in options) {
          copy = options[prop];

          if (prop === '__proto__' || target === copy) {
            continue;
          }

          if (copy && ((0, _isPlainObject["default"])(copy) || (copyIsArray = Array.isArray(copy)))) {
            src = target[prop];

            if (copyIsArray && !Array.isArray(src)) {
              clone = [];
            } else if (!copyIsArray && !(0, _isPlainObject["default"])(src)) {
              clone = {};
            } else {
              clone = src;
            }

            copyIsArray = false;
            target[prop] = deepCopy(clone, copy);
          } else if (copy !== undefined) {
            target[prop] = copy;
          }
        }
      }
    }

    return target;
  }

  function valueByKeyPath(value, keyPath) {
    if (value === undefined || value === null) {
      return value;
    }

    var key = keyPath[0],
        _keyPath = keyPath.slice(1);

    var _value = value[key];
    return _keyPath.length > 0 ? valueByKeyPath(_value, _keyPath) : _value;
  }

  var BaseStore = /*#__PURE__*/function () {
    function BaseStore() {
      this.state = reactive({});
      this.actions = new Map();
    }

    var _proto3 = BaseStore.prototype;

    _proto3.getState = function getState() {
      return this.state;
    };

    _proto3.reactive = function reactive(namespace, raw) {
      var subState = this.state[namespace] || {};
      this.state[namespace] = deepCopy(subState, raw);
    };

    _proto3.observe = function observe(key, fn, options) {
      var _this2 = this;

      var stateObserveFunction = _observe2(function () {
        var keyPath = key.split('.');
        fn(deepCopy(valueByKeyPath(_this2.state, keyPath)));
      }, options);

      stateObserveFunction.unobserve = function stateUnobserve() {
        if (!stateObserveFunction.unobserved) {
          unobserve(stateObserveFunction);
        }
      };

      return stateObserveFunction;
    };

    _proto3.registerAction = function registerAction(namespace, actions) {
      var _this3 = this;

      var _actions = this.actions.get(namespace);

      if (!_actions) {
        _actions = {};
      }

      Object.assign(_actions, Object.entries(actions).reduce(function (binded, _ref6) {
        var actionName = _ref6[0],
            action = _ref6[1];
        binded[actionName] = action.bind(null, {
          rootState: _this3.state,
          state: _this3.state[namespace],
          actions: _actions
        });
        return binded;
      }, {}));

      if (!(0, _isEmpty["default"])(_actions)) {
        this.actions.set(namespace, _actions);
      }
    };

    _proto3.unregisterAction = function unregisterAction(namespace) {
      this.actions["delete"](namespace);
    };

    _proto3.dispatch = function dispatch(actionName) {
      var _actionName$split = actionName.split('/'),
          namespace = _actionName$split[0],
          _actionName = _actionName$split[1];

      var _actions = this.actions.get(namespace);

      if (!_actions) {
        return;
      }

      var action = _actions[_actionName];

      for (var _len4 = arguments.length, payload = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
        payload[_key5 - 1] = arguments[_key5];
      }

      return action && action.apply(void 0, payload);
    };

    _proto3.getDetail = function getDetail() {
      var action = [];
      this.actions.forEach(function (subActions, namespace) {
        action.push({
          appModuleName: namespace,
          namespace: namespace,
          actions: Object.keys(subActions)
        });
      });
      return {
        state: deepCopy({}, this.state),
        action: action
      };
    };

    return BaseStore;
  }();

  var BaseEventBus = /*#__PURE__*/function () {
    function BaseEventBus() {
      this.subscribes = {};
      this.namespaceSubscribes = {};
    }

    var _proto4 = BaseEventBus.prototype;

    _proto4.addListener = function addListener(namespace, type, listener) {
      this.subscribes[type] = this.subscribes[type] || [];
      this.subscribes[type].push(listener);
      this.namespaceSubscribes[namespace] = this.namespaceSubscribes[namespace] || {};
      this.namespaceSubscribes[namespace][type] = this.namespaceSubscribes[namespace][type] || [];
      this.namespaceSubscribes[namespace][type].push(listener);
    };

    _proto4.removeListener = function removeListener(namespace, type, listener) {
      if (!this.subscribes[type]) {
        return;
      }

      this.subscribes[type] = (0, _difference["default"])(this.subscribes[type], [listener]);
      var appModuleSubscribe = this.namespaceSubscribes[namespace] || {};
      appModuleSubscribe[type] = (0, _difference["default"])(appModuleSubscribe[type] || [listener], [listener]);

      if (this.subscribes[type].length === 0) {
        delete this.subscribes[type];
      }

      if (appModuleSubscribe[type].length === 0) {
        delete this.namespaceSubscribes[namespace][type];
      }
    };

    _proto4.triggerListener = function triggerListener(type) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key6 = 1; _key6 < _len5; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      (this.subscribes[type] || []).forEach(function (fun) {
        fun && fun.apply(void 0, deepCopy(args));
      });
    };

    _proto4.clearListenerForModule = function clearListenerForModule(namespace) {
      var _this4 = this;

      var appModuleSubscribe = this.namespaceSubscribes[namespace];

      if (!appModuleSubscribe) {
        return;
      }

      Object.entries(appModuleSubscribe).map(function (_ref7) {
        var type = _ref7[0],
            listeners = _ref7[1];
        _this4.subscribes[type] = (0, _difference["default"])(_this4.subscribes[type], listeners);

        if (_this4.subscribes[type].length === 0) {
          delete _this4.subscribes[type];
        }
      });
      delete this.namespaceSubscribes[namespace];
    };

    _proto4.getDetail = function getDetail() {
      return Object.entries(this.namespaceSubscribes).map(function (_ref8) {
        var namespace = _ref8[0],
            subscribes = _ref8[1];
        return {
          appModuleName: namespace,
          namespace: namespace,
          subscribes: Object.entries(subscribes).reduce(function (events, _ref9) {
            var _extends2;

            var key = _ref9[0],
                value = _ref9[1];
            return (0, _extends3["default"])({}, events, (_extends2 = {}, _extends2[key] = value.length, _extends2));
          }, {})
        };
      });
    };

    return BaseEventBus;
  }();

  var DEFAULT_NAMESPACE = '__GlobalContext__';
  var SPA_GLOBAL_PROVIDER = '__SPA_GLOBAL_PROVIDER__';

  var GlobalProvider = /*#__PURE__*/function () {
    function GlobalProvider() {
      this.baseStore = new BaseStore();
      this.baseEventBus = new BaseEventBus();
    }

    var _proto5 = GlobalProvider.prototype;

    _proto5.getStatusDetail = function getStatusDetail() {
      return (0, _extends3["default"])({}, this.baseStore.getDetail(), {
        eventbus: this.baseEventBus.getDetail()
      });
    };

    return GlobalProvider;
  }();

  var _globalProvider = globalStorage.get(SPA_GLOBAL_PROVIDER);

  if (!_globalProvider) {
    _globalProvider = new GlobalProvider();
    globalStorage.set(SPA_GLOBAL_PROVIDER, _globalProvider);
  }

  function dispatch(actionName) {
    var _globalProvider$baseS;

    if (!isBrowser) {
      console.warn("[globalProvider] used dispatch:" + actionName + " in a non-browser environment");
    }

    for (var _len6 = arguments.length, payload = new Array(_len6 > 1 ? _len6 - 1 : 0), _key7 = 1; _key7 < _len6; _key7++) {
      payload[_key7 - 1] = arguments[_key7];
    }

    return (_globalProvider$baseS = _globalProvider.baseStore).dispatch.apply(_globalProvider$baseS, [actionName].concat(payload));
  }

  function observe$1(key, fn, options) {
    if (!isBrowser) {
      console.warn("[globalProvider] used observe:" + key + " in a non-browser environment");
    }

    return _globalProvider.baseStore.observe(key, fn, options);
  }

  function on(type, listener, namespace) {
    if (namespace === void 0) {
      namespace = DEFAULT_NAMESPACE;
    }

    if (!isBrowser) {
      console.warn("[globalProvider] used on:" + type + " in a non-browser environment");
    }

    _globalProvider.baseEventBus.addListener(namespace, type, listener);
  }

  function off(type, listener, namespace) {
    if (namespace === void 0) {
      namespace = DEFAULT_NAMESPACE;
    }

    if (!isBrowser) {
      console.warn("[globalProvider] off:" + type + " observe in a non-browser environment");
    }

    _globalProvider.baseEventBus.removeListener(namespace, type, listener);
  }

  function once(type, listener, namespace) {
    if (namespace === void 0) {
      namespace = DEFAULT_NAMESPACE;
    }

    var _listener = function _listener() {
      listener && listener.apply(void 0, arguments);
      off(type, _listener, namespace);
    };

    if (!isBrowser) {
      console.warn("[globalProvider] used once:" + type + " in a non-browser environment");
    }

    on(type, _listener, namespace);
  }

  function emit(type) {
    var _globalProvider$baseE;

    if (!isBrowser) {
      console.warn("[globalProvider] used emit:" + type + " in a non-browser environment");
    }

    for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key8 = 1; _key8 < _len7; _key8++) {
      args[_key8 - 1] = arguments[_key8];
    }

    (_globalProvider$baseE = _globalProvider.baseEventBus).triggerListener.apply(_globalProvider$baseE, [type].concat(args));
  }

  function useStore(store, namespace) {
    if (namespace === void 0) {
      namespace = DEFAULT_NAMESPACE;
    }

    var state = store.state,
        actions = store.actions;
    var provider = isBrowser ? _globalProvider : new GlobalProvider();
    state && provider.baseStore.reactive(namespace, state);
    actions && provider.baseStore.registerAction(namespace, actions);

    var _observe = isBrowser ? observe$1 : function (key, fn, options) {
      return provider.baseStore.observe(key, fn, options);
    };

    var _dispatch = isBrowser ? dispatch : function (actionName) {
      var _provider$baseStore;

      for (var _len8 = arguments.length, payload = new Array(_len8 > 1 ? _len8 - 1 : 0), _key9 = 1; _key9 < _len8; _key9++) {
        payload[_key9 - 1] = arguments[_key9];
      }

      return (_provider$baseStore = provider.baseStore).dispatch.apply(_provider$baseStore, [actionName].concat(payload));
    };

    return {
      getState: function getState(isReactive) {
        var rootState = provider.baseStore.getState();
        return isReactive ? rootState : deepCopy({}, rootState);
      },
      observe: _observe,
      dispatch: _dispatch
    };
  }

  var globalProvider = _globalProvider;
  _exports.globalProvider = globalProvider;
});
//# sourceMappingURL=global-provider.js.map
